import { Dispatch } from "react";
import { Types } from "./TrainingPlansContext";

export const createTrainingPlanModal = (
  { _id = "", createModalTrainingPlan = true }: any,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.CREATE_TRAININGPLAN,
    payload: {
      createModalTrainingPlan,
    },
  });
};
export const deleteTrainingPlanModal = (
  _id = "",
  deleteModalTrainingPlan = true,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.DELETE_TRAININGPLAN,
    payload: {
      _id,
      deleteModalTrainingPlan,
    },
  });
};

export const updateModalTrainingPlan = ( _id = "", updateModalTrainingPlan=true, dispatch: Dispatch<any>): void =>{
  dispatch({
    type: Types.UPDATE_TRAININGPLAN,
    payload:{
      _id,
      updateModalTrainingPlan,
    },
  });
};

export const clearTrainingPlan = (
  {
    _id = "",
    createModalTrainingPlan = false,
    deleteModalTrainingPlan = false,
    updateModalTrainingPlan = false
  }: any,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.CLEAR_TRAININGPLAN,
    payload: {
      _id,
      createModalTrainingPlan,
      deleteModalTrainingPlan,
      updateModalTrainingPlan
    },
  });
};
export const createUserTPModal = (
  _id = "",
  createModalUserTP = true,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.CREATE_USER_TP,
    payload: {
      _id,
      createModalUserTP,
    },
  });
};

export const clearUserTPModal = (
  _id = "",
  createModalUserTP = false,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.CLEAR_USER_TP,
    payload: {
      _id,
      createModalUserTP,
    },
  });
};
